import request from "@/utils/request";

export function token(data) {
  return request({
    url: "/api/admin/auth/login/",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
}

export function me(params) {
  return request({
    url: "/api/admin/auth/me/",
    method: "get",
    params,
  });
}
